import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const optEmail = (optEmailData) => async (dispatch) => {
    try {
        const { data } = await api.optEmail(optEmailData);

        dispatch({
            type: Actions.OPT_EMAIL,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}